import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-page-header-toolbar',
  template: '<ng-content />',
  styleUrls: ['./page-header-toolbar.component.scss']
})
export class PageHeaderToolbarComponent {
}
